import { ThemeProvider } from '@mui/material';
import React, { memo, useState } from 'react';

import { themeCreator } from './base';

export const ThemeContext = React.createContext(
  (themeName: string): void => {}
);

const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = memo(
  (props) => {
    const curThemeName = localStorage.getItem('appTheme') || 'LogTheme';
    const [themeName, _setThemeName] = useState(curThemeName);
    const theme = themeCreator(themeName);

    const setThemeName = (themeName: string): void => {
      localStorage.setItem('appTheme', themeName);
      _setThemeName(themeName);
    };

    return (
      <ThemeContext.Provider value={setThemeName}>
        <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
      </ThemeContext.Provider>
    );
  }
);

export default ThemeProviderWrapper;
